import React from "react";

import { Headline } from "../../../components/Headline";
import { StructuredTextRenderer } from "../../../components/StructuredTextRenderer";
import { Tagline } from "../../../components/Tagline/Tagline";

import * as styles from "./component.module.less";

export function NestedLinkBox({
    data: { link, semanticOfHeadline, headline, tagline },
    type,
    hasLightBackground = true
}) {
    return (
        <div className={styles.linkBox}>
            {tagline && (
                <Tagline hasLightBackground={hasLightBackground}>
                    {tagline}
                </Tagline>
            )}

            {headline && (
                <Headline
                    semanticOfHeadline={semanticOfHeadline}
                    hasLightBackground={hasLightBackground}
                >
                    {headline}
                </Headline>
            )}

            <StructuredTextRenderer
                itemLinkType="primary"
                itemLinkIcon="arrowRight"
                itemLinkIconPosition="right"
                data={link}
                contentElementType={type}
            />
        </div>
    );
}
